<template>
  <div>Screen</div>
</template>

<script>
export default {};
</script>

<style></style>
